import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiEndpoint } from '../../constants';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestError } from '../../types';
import { RequestResponse } from './types';

export const getDetailsLink = createAsyncThunk<
  RequestResponse,
  undefined,
  { rejectValue: RequestError }
>('virtualCard/detailsLink/fetch', async (_, { rejectWithValue }) => {
  try {
    const url = ApiEndpoint.CardDetails;
    const params = prepareQuery();

    const {
      body: { error, result },
    } = await superagent.get(url).query(params);

    if (error) {
      throw error;
    }

    return result;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  }
});
